const app_params = {
    basepath: '/archive/catalog', 
    version: '10.0.0',
    gaTag: 'G-TAG',
};

export default app_params;